import Moment from 'moment'

const dateFormat = 'YYYY-MM-DD'
const startFormat = 'YYYY-MM-DD 00:00:00'
const endFormat = 'YYYY-MM-DD 23:59:59'

export function generateListDate (startDate, endDate) {
  startDate = Moment(startDate).startOf('day').format(dateFormat)
  endDate = Moment(endDate).endOf('day').format(dateFormat)

  const listDate = {}
  const dateMove = new Date(startDate)
  let strDate = startDate

  while (strDate < endDate) {
    strDate = dateMove.toISOString().slice(0, 10)
    listDate[strDate] = 0
    dateMove.setDate(dateMove.getDate() + 1)
  }

  return listDate
}

export function convertArrayToObject (value) {
  const list = {}
  for (let i = 0; i < value.length; i++) {
    const date = new Date(value[i].date)
    const key = date.toISOString().split('T')[0]
    list[key] = value[i].count
  }
  return list
}

export default { dateFormat, startFormat, endFormat }
